package com.example.blogmultiplatform.pages.movie

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.Color
import org.w3c.dom.Text


/*
* BlogMultiplatform.com.example.blogmultiplatform.pages.custom
* Created by SAMET BAYAT 
* on 16.07.2024 at 2:27 PM
* Copyright (c) 2024 UNITED WORLD. All rights reserved.
*/

@Page//(routeOverride = "movie")
@Composable
fun MovieOfTheWeek() {
    Column(
        modifier = Modifier.fillMaxSize(),
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SpanText("Movie")

    }
}